<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <template v-if="form.beforeStr.directorUserInfoMap && form.beforeStr.departmentMap">
            <div class="item">姓名：{{form.beforeStr.departmentMap.director_user_type === 20?form.beforeStr.directorUserInfoMap.name:form.beforeStr.directorUserInfoMap.real_name}}</div>
          </template>
          <template v-if="form.beforeStr.departmentMap">
            <div class="item">部门名称：{{form.beforeStr.departmentMap.name}}</div>
            <div class="item">状态：{{form.beforeStr.departmentMap.is_enable?'启用':'禁用'}}</div>
          </template>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr ">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <template v-if="form.afterStr.directorUserInfoMap && form.afterStr.departmentMap">
            <div class="item">姓名：{{form.afterStr.departmentMap.director_user_type === 20?form.afterStr.directorUserInfoMap.name:form.afterStr.directorUserInfoMap.real_name}}</div>
          </template>
          <template v-if="form.afterStr.departmentMap">
            <div class="item">部门名称：{{form.afterStr.departmentMap.name}}</div>
            <div class="item">状态：{{form.afterStr.departmentMap.is_enable?'启用':'禁用'}}</div>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;

      })
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
</style>
